/**
 * Catch-all 404. The router rests on this for unknown paths; routed from
 * the `notFoundComponent` on the root route.
 */

import type { ReactElement } from "react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { Link } from "@tanstack/react-router";

export function NotFoundPage(): ReactElement {
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 6, md: 12 } }}>
      <Stack spacing={3} alignItems="flex-start">
        <Box>
          <Typography variant="h1">Not found</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            We couldn’t find the page you were looking for.
          </Typography>
        </Box>
        <Button component={Link} to="/sites" variant="contained">
          Back to sites
        </Button>
      </Stack>
    </Container>
  );
}
